import { MODULE_KIND } from 'types/modules';
import { GoogleModuleStateModel } from 'models/Module/ModuleState';

export default {
  [MODULE_KIND.GOOGLE_SHEETS]: GoogleModuleStateModel
};
